import "../css/home-page.css";
import "../css/media-query.css";
import { FaInstagram, FaWhatsapp, FaDownload } from "react-icons/fa";

function Navbar() {
  return (
    <header className="header">
      <footer className="footer">
        <p style={{ fontSize: "10px", margin: 0 }}>
          © 2026 திருப்பரப்பு பேரூர் – தமிழக வெற்றி கழகம்
        </p>

        <div className="social-icons">
          <a href="https://instagram.com/tvk.thirparappu" target="_blank" rel="noreferrer">
            <FaInstagram />
          </a>

          <a href="https://wa.me/9787568747" target="_blank" rel="noreferrer">
            <FaWhatsapp />
          </a>

          <a href="/tvk v2.0.apk" download>
            <FaDownload />
          </a>
        </div>
      </footer>
    </header>
  );
}

export default Navbar;